import Vue from "vue";
import VueRouter from "vue-router";
import { firebase } from "../helpers/firebase";
import _get from "lodash/get";
import Login from "../views/Login.vue";
import Home from "../views/Home/index.vue";
import Dash from "../views/Home/Dashboard.vue";
import UsuariosBase from "../views/Home/usuarios/index.vue";
import Grupos from "../views/Home/grupos/index.vue";
import Mensajes from "../views/Home/salas/mensajes.vue";
import Configs from "../views/Home/configuracion";
import Colegios from "../components/configuraciones/colegios";
import Usuarios from "../components/configuraciones/usuarios";

Vue.use(VueRouter);

function checkAuth() {
  return new Promise(resolve => firebase.auth().onAuthStateChanged(resolve));
}

function isSuper() {
  return new Promise(resolve =>
    firebase.auth().onAuthStateChanged(user => {
      if (!user) return !!user;
      return firebase
        .firestore()
        .collection("usuarios")
        .doc(`dc_${user.uid}`)
        .get()
        .then(userDb => resolve(!!userDb.data().superuser));
    })
  );
}

function puedenUsuarios() {
  let ColeActual = localStorage.getItem("ColeActual");
  return new Promise(resolve =>
    firebase.auth().onAuthStateChanged(user => {
      if (!user) return !!user;
      return firebase
        .firestore()
        .collection("usuarios")
        .doc(`dc_${user.uid}`)
        .get()
        .then(userDb =>
          resolve(
            !!_get(userDb.data(), `superuser`) ||
              !!_get(
                userDb.data(),
                `permisos.${ColeActual}.usuarios.creacion`
              ) ||
              !!_get(
                userDb.data(),
                `permisos.${ColeActual}.usuarios.modificacion`
              )
          )
        );
    })
  );
}

function puedenGrupos() {
  let ColeActual = localStorage.getItem("ColeActual");
  return new Promise(resolve =>
    firebase.auth().onAuthStateChanged(user => {
      if (!user) return !!user;
      return firebase
        .firestore()
        .collection("usuarios")
        .doc(`dc_${user.uid}`)
        .get()
        .then(userDb =>
          resolve(
            !!_get(userDb.data(), `superuser`) ||
              !!_get(userDb.data(), `permisos.${ColeActual}.grupos.creacion`) ||
              !!_get(
                userDb.data(),
                `permisos.${ColeActual}.grupos.modificacion`
              )
          )
        );
    })
  );
}

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    async beforeEnter(to, from, next) {
      if (!(await checkAuth())) next();
      else next("/");
    }
  },
  {
    path: "/",
    component: Home,
    async beforeEnter(to, from, next) {
      if (await checkAuth()) next();
      else next("/login");
    },
    children: [
      {
        path: "",
        name: "Wall",
        component: Dash
      },
      {
        path: "usuarios",
        name: "Usuarios",
        async beforeEnter(to, from, next) {
          if (await puedenUsuarios()) next();
          else next("/");
        },
        component: UsuariosBase
      },
      {
        path: "Grupos",
        name: "grupos",
        async beforeEnter(to, from, next) {
          if (await puedenGrupos()) next();
          else next("/");
        },
        component: Grupos
      },
      {
        path: "sala/:id",
        name: "SalaMensajes",
        component: Mensajes
      },
      {
        path: "configuracion",
        name: "Configuracion",
        component: Configs,
        redirect: { name: "configColegios" },
        async beforeEnter(to, from, next) {
          if (await isSuper()) next();
          else next("/");
        },
        children: [
          {
            path: "colegios",
            name: "configColegios",
            component: Colegios
          },
          {
            path: "usuarios",
            name: "configUsuarios",
            component: Usuarios
          }
        ]
      }
    ]
  },
  { path: "*", redirect: "/login" }
];

const router = new VueRouter({
  routes
});

export default router;
